import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const fetchProcesses = createAsyncThunk(
  'processes/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get('/processes');
      if (data.success) return data.data || [];
      return rejectWithValue(data.error || 'Ошибка при загрузке');
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const processSlice = createSlice({
  name: 'processes',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcesses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcesses.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchProcesses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Ошибка';
      });
  },
});

export default processSlice.reducer;
